import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";

function list(params) {
  const { max, offset, ...rest } = params;
  const newParams = { take: max, skip: offset, ...rest };
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    if (!Array.isArray(value)) {
      qsParams.append(key, value);
    } else {
      value.forEach(elem => qsParams.append(key, elem));
    }
  }

  const url = `/channel?${qsParams.toString()}`;
  ENABLE_API_DBG && console.log(`api.channel.list: url = ${url}`);
  return request({
    url,
    method: "get",
    data: params,
  });
}

function listExtChnl(params) {
  const { max, offset, ...rest } = params;
  const newParams = { take: max, skip: offset, ...rest };
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    if (!Array.isArray(value)) {
      qsParams.append(key, value);
    } else {
      value.forEach(elem => qsParams.append(key, elem));
    }
  }

  const url = `/channel/subscribeable?${qsParams.toString()}`;
  ENABLE_API_DBG && console.log(`api.channel.listExtChnl: url = ${url}`);
  return request({
    url,
    method: "get",
    data: params,
  });
}



function get(itemId) {
  return request({
    url: `/channel/${itemId}`,
    method: "get",
  });
}
function search(params) {
  return request({
    url: `/channel/search`,
    method: "post",
    data: params,
  });
}
function add(params) {
  return request({
    url: `/channel`,
    method: "post",
    data: params,
  });
}
function update(params) {
  const { id, ...outParams } = params;
  const url = `/channel/${id}`;
  ENABLE_API_DBG &&
    console.log(
      `api.channel.update: url = ${url}, outParams = ${JSON.stringify(
        outParams
      )}`
    );
  return request({
    url,
    method: "patch",
    data: outParams,
  });
}
function remove(itemId) {
  return request({
    url: `/channel/${itemId}`,
    method: "delete",
  });
}
export default {
  list,
  listExtChnl,
  search,
  add,
  update,
  remove,
  get,
};
